import { ApplicationConsentType, RecordApplicationConsentInput, RecordApplicationConsentResponse } from '../../gql/graphql';
import { createForbiddenErrorMessage, createUnauthorizedErrorMessage } from '../../helpers/security/security';
import applicationFormService from '../../services/applicationForm.service';
import { NetworkError } from '../../state-machine/actions/genericActions';
import getApplicationId from '../../utils/commonState/getApplicationId';

const recordDebitCardConsent = async (context: any, event?: any): Promise<RecordApplicationConsentResponse | undefined> => {
  try {
    const input: RecordApplicationConsentInput = {
      applicationId: getApplicationId(context.application),
      consentType: ApplicationConsentType.DebitCardAuthorization,
    };

    const { data } = await applicationFormService.recordApplicationConsent(input);
    return data?.recordApplicationConsent as RecordApplicationConsentResponse;
  } catch (err: any) {
    var error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        error.forbiddenError = createForbiddenErrorMessage(err);
        break;
      case 401:
        error.unauthorizedError = createUnauthorizedErrorMessage(err);
        break;
      default:
        error.errorGeneral = err;
        break;
    }
    throw error;
  }
};

export default recordDebitCardConsent;
